import type { Event } from '@patsnap/tahiti-core';
import type { CompareFeatureItem, FeatureCompareState, FeatureDismantlingLocalData, IdParams, LangModeInfo, PatentItemInfo } from '../types';

export const FeatureCompareService = Symbol.for('FeatureCompareService');

export interface FeatureCompareService {
    readonly onStatesChange: Event<FeatureCompareState>;
    getModelData(): FeatureCompareState;
    updateModelData(data: Partial<FeatureCompareState>): void;

    getClaimFeatureData(params: IdParams): Promise<void>; // 获取权力要求特征数据

    getFeatureCompareResult(targetInfo: PatentItemInfo): Promise<void>; // 获取对比结果

    getFeatureCompareTranslation(params: LangModeInfo): Promise<void>; // 获取翻译数据

    getClaimFeatureLocalData(params: IdParams): Promise<FeatureDismantlingLocalData>; // 获取本地存储数据

    exportExcel(data: CompareFeatureItem[]): Promise<void>; // 导出

    alertWarning(message: string, showClose: boolean): void // 重置，关闭

    reset(): void // 重置，关闭
}